module.exports = __webpack_public_path__ + "img/mobileworkorderBanner.d66be9c5.png";